import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { accountRoutes } from '../../../../constants/routes';

const STATIC_BANNER_ID = 'cookie-banner-static';

const setCookie = (name, value, days = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
};

const getCookie = (name) => {
    const match = document.cookie.match(
        new RegExp(`(^| )${name}=([^;]+)`),
    );
    return match ? match[2] : null;
};

export default function PrivacyCoockies() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        const consent = getCookie('cookieConsent');

        if (consent) {
            updateGoogleAnalytics(consent);
            return undefined;
        }

        const staticBanner = document.getElementById(STATIC_BANNER_ID);
        if (!staticBanner || staticBanner.hidden) {
            setTimeout(() => setIsVisible(true), 400);
            return undefined;
        }

        const expand = (event) => {
            if (!event.target.closest('.cookie-banner__toggle')) return;
            staticBanner.remove();
            setIsExpanded(true);
            setIsVisible(true);
        };
        staticBanner.addEventListener('click', expand);
        return () => staticBanner.removeEventListener('click', expand);
    }, []);

    const updateGoogleAnalytics = (consentType) => {
        const isAccepted = consentType === 'accepted';

        if (typeof gtag !== 'undefined') {
            const storageValue = isAccepted ? 'granted' : 'denied';
            gtag('consent', 'update', {
                analytics_storage: storageValue,
                ad_storage: storageValue,
                functionality_storage: storageValue,
                personalization_storage: storageValue,
            });
            gtag('event', 'consent_update', {
                event_category: 'consent',
                consent_type: isAccepted ? 'all_accepted' : 'all_declined',
            });
        }

        if (isAccepted && typeof window.__loadClarity === 'function') {
            window.__loadClarity();
        }
    };

    const handleChoice = (accepted) => {
        const consentType = accepted ? 'accepted' : 'declined';

        setCookie('cookieConsent', consentType);
        updateGoogleAnalytics(consentType);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            className={`cookie-banner cookie-banner--visible${isExpanded ? ' cookie-banner--expanded' : ''}`}
        >
            <div className="cookie-banner__container">
                <div className="cookie-banner__content">
                    <div className="cookie-banner__icon">🍪</div>
                    <div className="cookie-banner__text">
                        <div className="cookie-banner__description">
                            {isExpanded ? t('cookieConsentText') : t('cookieConsentShort')}
                            {isExpanded && (
                                <>
                                    {' '}
                                    <a
                                        href={accountRoutes.PRIVACY}
                                        className="cookie-banner__link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t('privacyPolicyLinkText')}
                                    </a>
                                </>
                            )}
                        </div>
                        <button
                            type="button"
                            className="cookie-banner__toggle"
                            onClick={() => setIsExpanded((v) => !v)}
                            aria-expanded={isExpanded}
                        >
                            {t('more')}
                            <span className={`cookie-banner__chevron${isExpanded ? ' cookie-banner__chevron--up' : ''}`} aria-hidden="true">▾</span>
                        </button>
                    </div>
                </div>

                <div className="cookie-banner__actions">
                    <button
                        type="button"
                        className="cookie-banner__button cookie-banner__button--decline"
                        onClick={() => handleChoice(false)}
                    >
                        {t('applyNotAll')}
                    </button>
                    <button
                        type="button"
                        className="cookie-banner__button cookie-banner__button--accept"
                        onClick={() => handleChoice(true)}
                    >
                        {t('applyAll')}
                    </button>
                </div>
            </div>
        </div>
    );
}
